import { Component, OnInit } from '@angular/core';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { LandingService } from '../landing.service';
import { Benefits } from '../../../../models/benefits.model';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-benefits',
  templateUrl: './benefits.component.html',
  styleUrls: ['./benefits.component.scss', '../stylesGlobLanding.scss']
})
export class BenefitsComponent implements OnInit {
  url = environment.URL_AWS;
  Benefits: any;
  bandShowSlider: boolean;
  domainPage: string;
  paginatedBenefits: any[] = [];
  currentPage: number = 1;
  pageSize: number = 4; 

  constructor(private _LandingService: LandingService) {
    var host = window.location.host;
    const domain = host.split('.')[1];
    let data;
    if (domain == 'ampi') {
      this.domainPage = host.split('.')[0];

    } else {
      this.domainPage = window.location.host;
    }
  }

  async ngOnInit(){
    var host = window.location.host;
    const domain = host.split('.')[1];
    let data;
    if (domain == 'ampi') {
      this.domainPage = host.split('.')[0];

    } else {
      this.domainPage = window.location.host;
    }
    // this.domainPage = "sanluispotosi";
    console.log("este es el dominio", this.domainPage);
    
    document.documentElement.style.setProperty("--swiper-theme-color", "gray");
    this.Benefits = await this._LandingService.getServer('benefits', this.domainPage)
    this.getPageData();
    console.log("Benefits", this.Benefits)
    // this._LandingService.getServer('benefits', this.domainPage).then(
    //   (resp: Benefits[]) => {
    //     this.Benefits = resp;
    //     this.Benefits[0].link = true;
    //   }, (err: any) => {
    //     console.log("ERROR ", err);
    //   }
    // );

  }

  getPageData(): void {
    const startIndex = (this.currentPage - 1) * this.pageSize;
    this.paginatedBenefits = this.Benefits.slice(startIndex, startIndex + this.pageSize);
    console.log(this.paginatedBenefits)
  }

  goToPage(page: number): void {
    this.currentPage = page;
    this.getPageData();
  }

  redirectInmoapp() {
    window.open('https://inmoapp.mx/', '_blank');
  }

  public swiperResponsive: SwiperConfigInterface = {
    grabCursor: true,
    slidesPerView: 3,
    spaceBetween: 50,

    // init: false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    navigation: true,
    breakpoints: {
      1024: {
        slidesPerView: 3,
        spaceBetween: 40
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 30
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      320: {
        slidesPerView: 1,
        spaceBetween: 10
      }
    },
  };

}
